const ActiveStatisticsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2621_4699)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2398 18.6001C9.72546 18.7178 9.18999 18.78 8.64 18.78C4.69669 18.78 1.5 15.5833 1.5 11.64C1.5 7.69669 4.69669 4.5 8.64 4.5C9.18999 4.5 9.72546 4.56219 10.2398 4.67991C8.10496 6.25302 6.71997 8.78477 6.71997 11.64C6.71997 14.4952 8.10496 17.027 10.2398 18.6001ZM12 17.9416C9.75056 16.7397 8.21997 14.3686 8.21997 11.64C8.21997 8.9114 9.75056 6.54029 12 5.3384C14.2494 6.54029 15.78 8.9114 15.78 11.64C15.78 14.3686 14.2494 16.7397 12 17.9416ZM12 19.6023C10.9671 20.0387 9.83175 20.28 8.64 20.28C3.86826 20.28 0 16.4117 0 11.64C0 6.86826 3.86826 3 8.64 3C9.83175 3 10.9671 3.24128 12 3.67767C13.0328 3.24128 14.1682 3 15.36 3C20.1317 3 24 6.86826 24 11.64C24 16.4117 20.1317 20.28 15.36 20.28C14.1682 20.28 13.0328 20.0387 12 19.6023ZM13.7602 4.67991C14.2745 4.56219 14.81 4.5 15.36 4.5C19.3033 4.5 22.5 7.69669 22.5 11.64C22.5 15.5833 19.3033 18.78 15.36 18.78C14.81 18.78 14.2745 18.7178 13.7602 18.6001C15.895 17.027 17.28 14.4952 17.28 11.64C17.28 8.78477 15.895 6.25302 13.7602 4.67991Z"
          fill="#0AC4B2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9196 11.9624C16.9196 15.5424 14.7423 18.6139 11.6395 19.9248C8.53678 18.6139 6.35938 15.5424 6.35938 11.9624C6.35938 8.38234 8.53678 5.31086 11.6395 4C14.7422 5.31086 16.9196 8.38234 16.9196 11.9624ZM13.9739 7.07521L13.4415 6.22868L6.68599 10.4771L7.21835 11.3236L13.9739 7.07521ZM6.68638 14.3189L15.6937 8.65444L16.2261 9.50096L7.21874 15.1655L6.68638 14.3189ZM16.5849 13.0176L16.0526 12.1711L9.29707 16.4194L9.82943 17.266L16.5849 13.0176Z"
          fill="#0AC4B2"
        />
        <mask id="path-3-inside-1_2621_4699" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6395 19.9248C14.7423 18.6139 16.9196 15.5424 16.9196 11.9624C16.9196 8.38234 14.7422 5.31086 11.6395 4C8.53678 5.31086 6.35938 8.38234 6.35938 11.9624C6.35938 15.5424 8.53678 18.6139 11.6395 19.9248Z"
          />
        </mask>
        <path
          d="M11.6395 19.9248L11.0557 21.3065L11.6395 21.5531L12.2233 21.3065L11.6395 19.9248ZM11.6395 4L12.2233 2.61826L11.6395 2.37162L11.0557 2.61826L11.6395 4ZM15.4196 11.9624C15.4196 14.9185 13.6228 17.4585 11.0557 18.543L12.2233 21.3065C15.8617 19.7693 18.4196 16.1663 18.4196 11.9624H15.4196ZM11.0557 5.38174C13.6228 6.46628 15.4196 9.00623 15.4196 11.9624H18.4196C18.4196 7.75846 15.8617 4.15544 12.2233 2.61826L11.0557 5.38174ZM7.85938 11.9624C7.85938 9.00623 9.65623 6.46628 12.2233 5.38174L11.0557 2.61826C7.41732 4.15544 4.85938 7.75846 4.85938 11.9624H7.85938ZM12.2233 18.543C9.65624 17.4585 7.85938 14.9185 7.85938 11.9624H4.85938C4.85938 16.1663 7.41732 19.7693 11.0557 21.3065L12.2233 18.543Z"
          fill="#0AC4B2"
          mask="url(#path-3-inside-1_2621_4699)"
        />
      </g>
      <defs>
        <clipPath id="clip0_2621_4699">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ActiveStatisticsIcon;
